export const heroSlides = [
  {
    id: "news-1",
    title: "《星轨彼端》第二季正式定档，全新预告公开",
    summary:
      "官方公布第二季将于下季度开播，主角弦月与观测站成员将迎来更宏大的星海篇章。",
    tag: "头条推荐",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20style%20celestial%20starry%20night%20sky%20with%20a%20young%20heroine%20silhouette%20gazing%20at%20glowing%20constellations%2C%20deep%20blue%20and%20gold%20palette%2C%20cinematic%20wide%20key%20visual&width=1600&height=900&seq=hero-01&orientation=landscape",
  },
  {
    id: "news-2",
    title: "《深海夜航》剧场版首周票房刷新年度纪录",
    summary:
      "上映首周表现超出预期，成为本年度开局最好的动画电影之一，官方追加限定场次。",
    tag: "热映中",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20submarine%20gliding%20through%20deep%20ocean%20surrounded%20by%20bioluminescent%20creatures%2C%20moody%20teal%20and%20navy%20palette%2C%20cinematic%20film%20key%20visual%20wide&width=1600&height=900&seq=hero-02&orientation=landscape",
  },
  {
    id: "work-4",
    title: "《机甲纪元》硬核机设与群像叙事的双重看点",
    summary:
      "当战争由机甲代为进行，机师与座机之间形成了奇特的羁绊，理念的碰撞让战斗有了超越胜负的意义。",
    tag: "本周推荐",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20giant%20mecha%20standing%20before%20a%20dramatic%20sunset%20horizon%2C%20epic%20sci-fi%20anime%20key%20visual%2C%20deep%20blue%20and%20orange%20tones%2C%20wide%20cinematic%20composition&width=1600&height=900&seq=hero-03&orientation=landscape",
  },
  {
    id: "work-12",
    title: "《玻璃海之约》夏日青春物语温暖上线",
    summary:
      "在只能于夏天出现的海边小镇，两个少年许下关于未来的约定。透明感与一丝苦涩并存的动画。",
    tag: "编辑精选",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20two%20teenagers%20on%20a%20sunlit%20seaside%20town%20street%20with%20sparkling%20sea%20in%20the%20distance%2C%20nostalgic%20summer%20anime%20aesthetic%2C%20wide%20key%20visual&width=1600&height=900&seq=hero-04&orientation=landscape",
  },
  {
    id: "analysis-1",
    title: "《星轨彼端》结局解析：星轨到底在回应什么",
    summary:
      "从三处伏笔出发，梳理第一季埋下的叙事线索，解读那句“星轨回应的不是愿望，而是选择”。",
    tag: "深度解析",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20observatory%20dome%20interior%20with%20glowing%20star%20charts%20and%20floating%20constellation%20lines%2C%20mysterious%20deep%20blue%20and%20gold%20lighting%2C%20wide%20cinematic&width=1600&height=900&seq=hero-05&orientation=landscape",
  },
];